import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Emergency, RegisteredSignal } from 'src/app/web-api-client';

@Component({
  selector: 'app-emergency-details',
  templateUrl: './emergency-details.component.html',
  styleUrl: './emergency-details.component.scss'
})
export class EmergencyDetailsComponent implements OnInit {
  @Input() signal: RegisteredSignal;;
  @Input() emergency: Emergency;

  public onClose = new Subject<void>();

  public loading = false;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    console.log(this.signal);
    console.log(this.emergency)
  }

  public closeModal() {
    this.activeModal.close();
    this.onClose.next();
  }

  get emergencyId(): string {
    return this.emergency && this.emergency.id ? this.emergency.id.toString() : 'n/a';

  }
  get emergencyTitle(): string {
    return this.emergency.title || 'n/a';
  }

  get emergencyType(): string {
    return this.emergency.tipAvaria.title || 'n/a';
  }

  get workingGroup(): string {
    return this.emergency.workingGroups?.title || 'n/a';
  }

  get emergencyDescription(): string {
    return this.emergency.description || 'n/a';
  }

  get workingGroupManager(): string {
    if (!this.emergency.workingGroups) {
      return 'n/a';
    }

    const manager = this.emergency.workingGroups.manager;
    return manager
      ? `${manager.firstName} ${manager.fammilyName}`
      : "n/a";
  }

  get emergencyLocation(): google.maps.LatLngLiteral {
    return {
      lat: +this.emergency.latitude,
      lng: +this.emergency.longitude
    }
  }
}
